// ============================================
// ACTIONS - BOOK VECTORIZATION
// ============================================
import * as API from '../api'
import { prepareImagesForCms } from '../utils/cmsHtmlImages'

// ============================================
// 📋 CONSTANTES - Tipos de ações
// ============================================
export const FETCH_BOOK_VECTORIZATION = 'FETCH_BOOK_VECTORIZATION'
export const FETCHING_BOOK_VECTORIZATION = 'FETCHING_BOOK_VECTORIZATION'
export const FETCH_BOOK_VECTORIZATION_ERROR = 'FETCH_BOOK_VECTORIZATION_ERROR'

export const FETCH_BOOK_VECTORIZATIONS = 'FETCH_BOOK_VECTORIZATIONS'
export const FETCHING_BOOK_VECTORIZATIONS = 'FETCHING_BOOK_VECTORIZATIONS'
export const FETCH_BOOK_VECTORIZATIONS_ERROR = 'FETCH_BOOK_VECTORIZATIONS_ERROR'

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

export const CHANGE_BOOK_VECTORIZATION = 'CHANGE_BOOK_VECTORIZATION'
export const NEW_FORM_BOOK_VECTORIZATION = 'NEW_FORM_BOOK_VECTORIZATION'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const BOOK_VECTORIZATION_FORM_ERROR = 'BOOK_VECTORIZATION_FORM_ERROR'

export const ADD_BOOK_VECTORIZATION = 'ADD_BOOK_VECTORIZATION'
export const EDIT_BOOK_VECTORIZATION = 'EDIT_BOOK_VECTORIZATION'
export const DELETE_BOOK_VECTORIZATION = 'DELETE_BOOK_VECTORIZATION'

export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'

export const RESET_STATE = 'RESET_STATE'

// ============================================
// 🔓 MODAL
// ============================================
export const openModal = () => {
  return (dispatch) => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const closeModal = () => {
  return (dispatch) => {
    dispatch({ type: CLOSE_MODAL })
  }
}

// ============================================
// 📝 FORMULÁRIO
// ============================================
export const handleChangeBookVectorization = (bookVectorization) => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_BOOK_VECTORIZATION,
      bookVectorization,
    })
  }
}

export const newFormBookVectorization = () => {
  return (dispatch) => {
    dispatch({ type: NEW_FORM_BOOK_VECTORIZATION })
  }
}

export const setBookVectorizationFormTouched = (touched = true) => {
  return (dispatch) => {
    dispatch({ type: FORM_TOUCHED, touched })
  }
}

// ============================================
// ⚠️ TRATAMENTO DE ERROS
// ============================================
const getDuplicateKeyField = (errorMessage) => {
  const match = /collection: .* index: (.*)_/.exec(errorMessage) || []
  return match[1] || ''
}

const getInvalidField = (errorMessage) => {
  const match = /validation failed: (.*):/.exec(errorMessage) || []
  return match[1] || ''
}

export const handleBookVectorizationError = (res, dispatch) => {
  const { data = {} } = res
  const errorMessage = typeof data === 'string' ? data : data.message || ''

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({ type: FORM_TOUCHED })
      dispatch({
        type: BOOK_VECTORIZATION_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: getDuplicateKeyField(errorMessage) + ' já cadastrado.',
      })
      return res

    case errorMessage.includes('validation failed'):
      dispatch({ type: FORM_TOUCHED })
      dispatch({
        type: BOOK_VECTORIZATION_FORM_ERROR,
        field: getInvalidField(errorMessage),
        message: getInvalidField(errorMessage) + ' é inválido.',
      })
      return res

    default:
      return res
  }
}

// ============================================
// 📄 PAGINAÇÃO
// ============================================
export const handleChangePage = (page) => {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = (perPage) => {
  return (dispatch) => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

// ============================================
// 🔀 ORDENAÇÃO
// ============================================
export const changeOrderColumn = (column) => {
  return (dispatch) => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = (direction) => {
  return (dispatch) => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

// ============================================
// 🔄 RESET
// ============================================
export const resetState = () => {
  return (dispatch) => {
    dispatch({ type: RESET_STATE })
  }
}

// ============================================
// 📡 API CALLS - LISTAR TODOS
// ============================================
export const fetchBookVectorizations = (options) => {
  return (dispatch) => {
    dispatch({ type: FETCHING_BOOK_VECTORIZATIONS })

    return API.bookVectorization
      .getBookVectorizations(options)
      .then((res = {}) => {
        const { data } = res

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS,
          bookVectorizations: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage,
        })
      })
      .catch((err) => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR,
          err: message || 'Serviço indisponível. Verifique sua conexão.',
        })
      })
  }
}

// ============================================
// 📡 API CALLS - BUSCAR UM
// ============================================
export const fetchBookVectorization = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCHING_BOOK_VECTORIZATION, clear: true })
    dispatch({ type: OPEN_MODAL })

    return API.bookVectorization
      .getBookVectorization(id)
      .then(({ data }) => {
        dispatch({
          type: FETCH_BOOK_VECTORIZATION,
          bookVectorization: data,
        })
      })
      .catch((err) => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_BOOK_VECTORIZATION_ERROR,
          err: message || 'Serviço indisponível. Verifique sua conexão.',
        })
      })
  }
}

// ============================================
// 📡 API CALLS - CRIAR (Upload de Livro)
// ============================================
export const addBookVectorization = (formData) => {
  return (dispatch) => {
    return API.bookVectorization
      .addBookVectorization(formData)
      .then((apiResult) => {
        dispatch({
          type: ADD_BOOK_VECTORIZATION,
          bookVectorization: apiResult.data,
        })

        dispatch(fetchBookVectorizations())

        return apiResult
      })
      .catch((err) => {
        const { response = {} } = err

        handleBookVectorizationError(response, dispatch)

        return Promise.reject(err)
      })
  }
}

// ============================================
// 📡 API CALLS - EDITAR (NÃO IMPLEMENTADO)
// ============================================
export const editBookVectorization = (bookVectorization) => {
  const { book_name = '', titulo = '', isbn = '', id = '', arquivo = null } = bookVectorization

  const data = new FormData()
  data.append('titulo', book_name || titulo)
  data.append('isbn', isbn)

  if (arquivo && arquivo.name) {
    data.append('arquivo', arquivo)
  }

  return (dispatch) => {
    // Mantemos o loading da lista aqui pois geralmente edição fecha o modal rápido
    // ou se preferir, pode remover o FETCHING_BOOK_VECTORIZATIONS daqui também.
    dispatch({ type: FETCHING_BOOK_VECTORIZATIONS })
    dispatch({ type: FETCHING_BOOK_VECTORIZATION })

    return API.bookVectorization
      .editBookVectorization(data, id)
      .then(({ data }) => {
        dispatch({
          type: EDIT_BOOK_VECTORIZATION,
          bookVectorization: data,
        })
      })
      .catch((err) => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR,
          err: message || 'Endpoint de edição não implementado',
        })

        handleBookVectorizationError(response, dispatch)

        return Promise.reject(response)
      })
  }
}

// ============================================
// 📡 API CALLS - DELETAR POR ID (NÃO IMPLEMENTADO)
// ============================================
export const deleteBookVectorization = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCHING_BOOK_VECTORIZATIONS })

    return API.bookVectorization
      .deleteBookVectorization(id)
      .then((response) => {
        dispatch({
          type: DELETE_BOOK_VECTORIZATION,
          id: id,
        })
      })
      .catch((err) => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR,
          err: message || 'Endpoint de exclusão não implementado.',
        })

        return Promise.reject(err)
      })
  }
}

// ============================================
// 📡 API CALLS - RESTAURAR (NÃO IMPLEMENTADO)
// ============================================
export const restoreBookVectorization = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCHING_BOOK_VECTORIZATIONS })

    return API.bookVectorization
      .restoreBookVectorization(id)
      .then(({ data }) => {
        dispatch({
          type: EDIT_BOOK_VECTORIZATION,
          bookVectorization: data,
        })
      })
      .catch((err) => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR,
          err: message || 'Endpoint de restauração não implementado',
        })

        handleBookVectorizationError(response, dispatch)

        return Promise.reject(response)
      })
  }
}

// ============================================
// 📡 NOVOS ENDPOINTS (preparados para uso futuro)
// ============================================

export const deleteVectorsByIdVetor = (idVetor) => {
  return (dispatch) => {
    dispatch({ type: FETCHING_BOOK_VECTORIZATIONS })

    return API.bookVectorization
      .deleteVectorsByIdVetor(idVetor)
      .then((response) => {
        const { data } = response

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR, // Limpa loading
          err: false,
        })

        return Promise.resolve(data)
      })
      .catch((err) => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR,
          err: message || 'Erro ao deletar vetores',
        })

        return Promise.reject(err)
      })
  }
}

export const fetchBookFiles = (isbn) => {
  return (dispatch) => {
    return API.bookVectorization
      .getBookFiles(isbn)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

const appendIfPresent = (data, field, value) => {
  if (value !== undefined && value !== null && value !== '') {
    data.append(field, value)
  }
}

const padLeft = (value, size) => {
  var output = String(value || '')

  while (output.length < size) {
    output = '0' + output
  }

  return output
}

const getChapterIdVetor = (chapter) => {
  return chapter.idVetor || chapter.id_vetor || chapter.id || null
}

const getChapterOrder = (chapter, index) => {
  return chapter.ordem || chapter.order || chapter.numero || chapter.number || index + 1
}

const getGeneratedChapterCode = (chapter, bookData, index) => {
  if (chapter.codigo) return chapter.codigo

  const isbnDigits = String(bookData.isbn || '')
    .replace(/\D/g, '')
    .slice(0, 13)
  const bookCode = isbnDigits || 'LIVRO'

  return bookCode + '_S00C' + padLeft(getChapterOrder(chapter, index), 3)
}

const getSelectValue = (item) => {
  if (!item) return null
  return item.value || item._id || item.id || item
}

const getSelectValues = (items) => {
  if (!items || !items.map) return []

  return items
    .map(getSelectValue)
    .filter((value) => value !== undefined && value !== null && value !== '')
}

const appendSelectArray = (data, field, items) => {
  const values = getSelectValues(items)

  if (values.length) {
    data.append(field, JSON.stringify(values))
  }
}

const appendSelectReference = (data, field, item) => {
  const value = getSelectValue(item)

  if (value) {
    data.append(field, value)
  }
}

const getChapterHtml = (chapter) => {
  return prepareImagesForCms(chapter.conteudoHtml || chapter.conteudo || '')
}

const buildCmsChapterFormData = (chapter, bookData, index) => {
  const data = new FormData()
  const isbn = chapter.isbn || bookData.isbn || ''
  const tituloLivro = bookData.titulo || bookData.book_name || bookData.titulo_livro || ''
  const tituloCapitulo = chapter.titulo || chapter.capitulo || 'Capítulo'
  const conteudoHtml = getChapterHtml(chapter)
  const cms = bookData.cms || {}

  data.append('tipo', 'capitulo')
  data.append('titulo', tituloCapitulo)
  data.append('conteudoHtml', conteudoHtml)

  appendIfPresent(data, 'idVetor', getChapterIdVetor(chapter))
  appendIfPresent(data, 'isbn', isbn)
  appendIfPresent(data, 'tituloLivro', chapter.tituloLivro || tituloLivro)
  appendIfPresent(data, 'codigo', getGeneratedChapterCode(chapter, bookData, index))
  appendIfPresent(data, 'tituloSecao', chapter.tituloSecao)
  appendIfPresent(data, 'textoSecao', chapter.textoSecao)
  appendIfPresent(data, 'pesoDA', chapter.pesoDA)
  appendIfPresent(data, 'idioma', chapter.idioma)
  appendIfPresent(data, 'buscaPeso', chapter.buscaPeso)
  appendIfPresent(data, 'codigoProtheus', chapter.codigoProtheus || cms.codigoProtheus)
  appendIfPresent(data, 'edicaoLivro', chapter.edicaoLivro || cms.edicaoLivro)

  appendSelectArray(data, 'autores', chapter.autores)
  appendSelectArray(data, 'especialidades', chapter.especialidades)
  appendSelectArray(data, 'palavrasChave', chapter.palavrasChave)
  appendSelectArray(data, 'autoresSecao', chapter.autoresSecao)
  appendSelectArray(data, 'buscaPalavrasChave', chapter.buscaPalavrasChave)
  appendSelectArray(data, 'autoresLivro', chapter.autoresLivro || cms.autoresLivro)
  appendSelectArray(
    data,
    'especialidadesLivro',
    chapter.especialidadesLivro || cms.especialidadesLivro,
  )
  appendSelectReference(
    data,
    'livroReferencia',
    chapter.livroReferencia || cms.livroReferencia,
  )
  appendIfPresent(
    data,
    'copyrightLivro',
    chapter.copyrightLivro || cms.copyrightLivro || bookData.ano,
  )

  return data
}

export const saveBookChapterInCms = (
  chapter,
  bookData = {},
  index = 0,
  existingContentId = null,
) => {
  return () => {
    const idVetor = getChapterIdVetor(chapter)

    if (!idVetor) {
      return Promise.reject({
        message: 'O capítulo não possui idVetor e não pode ser comparado com o CMS.',
      })
    }

    const formData = buildCmsChapterFormData(chapter, bookData, index)
    const request = existingContentId
      ? API.content.editContent(formData, existingContentId)
      : API.content.addContent(formData, idVetor)

    return request.then((response) => ({
      data: response.data,
      replaced: !!existingContentId,
      idVetor,
    }))
  }
}

export const executeProcessing = () => {
  return (dispatch) => {
    // Se desejar feedback visual global, mantenha o dispatch.
    // Se quiser silencioso, pode remover.
    dispatch({ type: FETCHING_BOOK_VECTORIZATIONS })

    return API.bookVectorization
      .executeProcessing()
      .then((response) => {
        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR, // Limpa loading
          err: false,
        })

        return Promise.resolve(response.data)
      })
      .catch((err) => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_BOOK_VECTORIZATIONS_ERROR,
          err: message || 'Erro ao executar processamento',
        })

        return Promise.reject(err)
      })
  }
}

export const searchBooks = (query, isbn = null, topK = 5) => {
  return (dispatch) => {
    return API.bookVectorization
      .searchBooks(query, isbn, topK)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const updateIndexarInformed = (idVetor, indexarInformed) => {
  return (dispatch) => {
    return API.bookVectorization
      .updateIndexarInformed(idVetor, indexarInformed)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const fetchVectorsHistory = (params = {}) => {
  return (dispatch) => {
    return API.bookVectorization
      .getVectorsHistory(params)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/bookVectorization.js